import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({ 
  children, 
  className = '', 
  onClick 
}) => {
  const baseClasses = "bg-white rounded-xl border border-black shadow-lg hover:shadow-xl transition-shadow p-6";
  const combinedClasses = `${baseClasses} ${className}`;

  if (onClick) {
    return (
      <button 
        onClick={onClick}
        className={`${combinedClasses} cursor-pointer text-left w-full`}
      >
        {children}
      </button>
    );
  }

  return (
    <div className={combinedClasses}>
      {children}
    </div>
  );
}; 